import * as React from 'react';
import { DuaType } from '../../models/dua.model';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { RWebShare } from 'react-web-share';
import { AUDIOBASE } from '../../common/constant';

interface IDuaProps {
    dua: DuaType;
    isPinned: boolean;
    onTogglePin: (id: string) => void;
}

const Dua: React.FunctionComponent<IDuaProps> = ({ dua, isPinned, onTogglePin }) => {
    const { i18n, t } = useTranslation();
    const duaTitle = (i18n.language === "en" ? dua.en_Title : dua.ta_Title) ?? '';
    const transliteration = (i18n.language === "en" ? dua.en_Transliteration : dua.ta_Transliteration) ?? '';
    const translation = (i18n.language === "en" ? dua.en_Translation : dua.ta_Translation) ?? '';
    const predua = (i18n.language === "en" ? dua.en_Predua : dua.ta_Predua) ?? '';
    const source = (i18n.language === "en" ? dua.en_Source : dua.ta_Source) ?? '';
    const arabic = dua.Arabic ?? '';
    const duaId = `${dua.PartitionKey}${dua.RowKey}`;
    const shareText = `${arabic}\n\n${transliteration.replaceAll(',', ',\n')}\n\n${translation}`;

    function handlePlay(event: React.SyntheticEvent<HTMLAudioElement, Event>): void {
        var audios = document.getElementsByTagName('audio');
        for (var i = 0, len = audios.length; i < len; i++) {
            if (audios[i] !== event.target) {
                audios[i].pause();
            }
        }
    }

    return (
        <Card className='mt-3' id={dua.PartitionKey + dua.RowKey}>
            <Card.Header className='mt-5 duatamil' > {dua.RowKey} : {duaTitle}
                <a id={"item" + dua.PartitionKey + dua.RowKey} href={"#" + dua.PartitionKey + dua.RowKey} className="hash-link" aria-label={`Direct link to ${duaTitle}`} title={`Direct link to ${duaTitle}`}></a>
                <button
                    type="button"
                    className={`btn btn-sm float-end ${isPinned ? 'btn-warning' : 'btn-outline-warning'}`}
                    title={isPinned ? 'Unpin dua' : 'Pin dua'}
                    aria-label={isPinned ? `Unpin ${duaTitle}` : `Pin ${duaTitle}`}
                    onClick={() => onTogglePin(duaId)}
                >
                    <i className={`bi ${isPinned ? 'bi-pin-angle-fill' : 'bi-pin-angle'}`}></i>
                </button>
                <RWebShare
                    data={{
                        text: shareText,
                        url: `https://masjidetaqwa.in/dua/${dua.PartitionKey}${dua.RowKey}`,
                        title: `Masjid-e-Taqwa Dua Share: ${duaTitle}`
                    }}
                    onClick={() =>
                        console.log("shared successfully!")
                    }
                >
                    <button type="button" className="bi bi-share btn btn-success btn-sm float-end"></button>
                </RWebShare>
            </Card.Header>
            <Card.Body>
                <p >
                    <div className="duatamil">{predua}</div>
                </p>
                <p >
                    <div className="duaarabic">{arabic}</div>
                </p>
                <p >
                    <div className="">
                        {dua.audiofilename ?
                            <audio controls loop controlsList="nodownload" onPlay={handlePlay}>
                                <source src={AUDIOBASE + dua.audiofilename} type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            : ""}
                    </div>
                </p>
                <p>
                    <em>
                        <div className="duatamil" dangerouslySetInnerHTML={{ __html: transliteration.replaceAll(',', ',<br />') }} ></div>
                    </em>
                </p>
                <p>
                    <blockquote>
                        <div className="duatamil" dangerouslySetInnerHTML={{ __html: translation }} ></div></blockquote>
                </p>
                <footer className="blockquote-footer duatamil">
                    <cite title="Source Title">{t("source")}: {source}</cite>
                </footer>
            </Card.Body>
        </Card>
    );
};
export default Dua;
